export const truncateTooltipText = (text: string, limit = 1500): string => {
  if (!text) {
    return text;
  }

  if (text.length > limit) {
    return `${text.slice(0, limit)} ...more`;
  }

  return text;
};

export const extractPlainText = (text: string): string => {
  if (!text) {
    return '';
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = text;

  const div = document.createElement('div');
  div.innerHTML = textarea.value;

  return div.textContent?.replace(/\s+/g, ' ').trim() ?? '';
};
